<template>
    <form class="agent-chat__input" @submit.prevent="onSubmit">
        <textarea
            ref="textarea"
            class="agent-chat__textarea"
            :value="modelValue"
            :placeholder="placeholder"
            :disabled="busy"
            rows="1"
            @input="onInput"
            @keydown="onKeydown"
        ></textarea>

        <button
            v-if="busy"
            type="button"
            class="agent-chat__btn agent-chat__btn--stop"
            aria-label="Stop"
            @click="$emit('stop')"
        >
            &#9632;
        </button>
        <button
            v-else
            type="submit"
            class="agent-chat__btn agent-chat__btn--send"
            :disabled="!canSend"
            aria-label="Invia"
        >
            &#10148;
        </button>
    </form>
</template>

<script>
export default {
    name: 'AgentChatPromptInput',
    props: {
        modelValue: {
            type: String,
            default: '',
        },
        status: {
            type: String,
            default: 'ready',
        },
        placeholder: {
            type: String,
            default: 'Scrivi un messaggio...',
        },
    },
    emits: ['update:modelValue', 'send', 'stop'],
    computed: {
        busy() {
            return this.status === 'submitted' || this.status === 'streaming';
        },
        canSend() {
            return !this.busy && this.modelValue.trim().length > 0;
        },
    },
    methods: {
        onInput(event) {
            this.$emit('update:modelValue', event.target.value);
        },
        onKeydown(event) {
            if (event.key === 'Enter' && !event.shiftKey) {
                event.preventDefault();
                this.onSubmit();
            }
        },
        onSubmit() {
            if (!this.canSend) {
                return;
            }
            this.$emit('send');
        },
    },
};
</script>

<style scoped>
.agent-chat__input {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    padding: 12px;
    border-top: 1px solid #e2e8f0;
    background: #fff;
}

.agent-chat__textarea {
    flex: 1 1 auto;
    resize: none;
    max-height: 140px;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    padding: 8px 12px;
    font-size: 14px;
    line-height: 1.4;
    font-family: inherit;
    outline: none;
}

.agent-chat__textarea:focus {
    border-color: #ea580c;
    box-shadow: 0 0 0 2px rgba(234, 88, 12, 0.15);
}

.agent-chat__btn {
    flex: 0 0 auto;
    width: 38px;
    height: 38px;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
}

.agent-chat__btn--send {
    background: #ea580c;
}

.agent-chat__btn--send:disabled {
    background: #cbd5e1;
    cursor: not-allowed;
}

.agent-chat__btn--stop {
    background: #475569;
}
</style>
